// extracted by mini-css-extract-plugin
export default {"navBarContainer":"NavBar_navBarContainer__mLLaq","firstNavItem":"NavBar_firstNavItem__UZxjm","noBorder":"NavBar_noBorder__r3igt"};